import { ThemeAppearance } from "@atlaskit/lozenge-next";

export const getStatusCategoryStyleMapping = (
    status?: string
): ThemeAppearance => {
    switch (status) {
        case "atlassian investigating":
            return "inprogress";
        case "completed":
            return "success";
        default:
            return "default";
    }
};
